import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '..';
const FoldoutItem = _ref => {
  let {
    optionFlagKey,
    optionIconKey,
    optionDescriptionKey,
    optionTitleKey,
    optionSubTitleKey,
    item,
    handleItem
  } = _ref;
  const handleOnClick = e => {
    e.preventDefault();
    handleItem(item);
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleOnClick,
    className: "section-item"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-subtitle",
    iconClassName: item[optionFlagKey] && 'flag',
    iconName: item[optionIconKey] || item[optionFlagKey] && `flag-${item[optionFlagKey]}`,
    description: item[optionDescriptionKey],
    title: item[optionTitleKey],
    subTitle: item[optionSubTitleKey],
    type: "link"
  }));
};
FoldoutItem.propTypes = {
  optionFlagKey: PropTypes.string,
  optionIconKey: PropTypes.string,
  optionDescriptionKey: PropTypes.string,
  optionTitleKey: PropTypes.string,
  optionSubTitleKey: PropTypes.string,
  handleItem: PropTypes.func,
  item: PropTypes.object
};
export default /*#__PURE__*/memo(FoldoutItem);